import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import resolvePage from './pages'
import { registerServiceWorker } from './pwa'
import { syncSubscription } from './push'

// The layout paints a loading state before any of this bundle has downloaded. Clear it once
// React has actually rendered, so the two never overlap and the album is never a blank screen.
function dismissAppShell() {
  const shell = document.getElementById('app-shell')
  if (!shell) return

  shell.classList.add('is-done')
  shell.addEventListener('transitionend', () => shell.remove(), { once: true })
  // A tab in the background gets no transition events, so guarantee the removal.
  setTimeout(() => shell.remove(), 600)
}

createInertiaApp({
  resolve: (name) => resolvePage(name),
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
    requestAnimationFrame(dismissAppShell)
  },
  progress: { color: '#f4568c', showSpinner: false },
})

registerServiceWorker()

// Keeps the server's copy of this device's push endpoint current after the browser rotates it.
syncSubscription()
